export const GROUP_CHAT_MIN_OTHER_PARTICIPANTS_COUNT = 2

export const ChatTableCellName = {
  Buildings: 'buildings',
  Created: 'created',
  CreatedBy: 'created_by',
  LastMessage: 'last_message',
  LastMessageDate: 'last_message_date',
  Participants: 'participants',
  Requests: 'requests',
  Title: 'title',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
}
